/* index.js */

"use strict";
const _ = require("lodash");

module.exports = {
    typeFormatter,
};

function typeFormatter(row, cell, value, columnDef, dataContext) {
    const ele = document.createElement("base-icon-gl");
    _updateTypeIcon(ele, row, cell, value, columnDef, dataContext);
    return ele.outerHTML;
}

function _updateTypeIcon(ele, row, cell, value, columnDef, dataContext) {
    const {icon, title} = getIconData(row, cell, value, columnDef, dataContext);
    ele.dataset.icon = icon;
    ele.setAttribute("title", title);
}

function getIconData(row, cell, value, columnDef, dataContext) {
    let typeBaseGroupMap = _.get(dataContext, "typeBaseGroupMap");
    let detectedTypeBase = _.get(dataContext, "detectedTypeBase");
    // single edge case where icon name and it's title do not match
    if (typeBaseGroupMap[detectedTypeBase] === undefined) {
        return {icon: "common.default_device", title: "Unknown"};
    }
    return {
        icon: "common." + _.snakeCase(typeBaseGroupMap[detectedTypeBase]),
        title: detectedTypeBase,
    };
}
